// FIXME: https://github.com/nuxt/module-builder/issues/141#issuecomment-2078248248

import { isObject } from 'lodash-es';
import { computed } from 'vue';
import { defineNuxtPlugin, useHead, useNuxtApp } from '#imports';
import baseTheme from '#layers/ui/theme/base';

export default defineNuxtPlugin(() => {
	const nuxtApp = useNuxtApp();
	const theme = baseTheme;

	const palette = computed(() =>
		Object.entries(theme.palette).map(
			([color, shades]) => isObject(shades)
				? Object.entries(shades).map(
						([shade, value]) => `--theme-palette-${color}-${shade}: ${value};`,
					).join('\n')
				: '',
		).join('\n'));

	const root = computed(() => {
		return `@layer base {
  :root {
  ${palette.value}
  }
}`;
	});

	// Head
	const headData: any = {
		style: [{
			innerHTML: () => root.value,
			tagPriority: -2,
			id: 'monospace-theme',
			type: 'text/css',
		}],
	};

	// SPA mode
	if (import.meta.client && nuxtApp.isHydrating && !nuxtApp.payload.serverRendered) {
		const style = document.createElement('style');

		style.innerHTML = root.value;
		style.dataset.monospaceTheme = '';
		document.head.append(style);

		headData.script = [{
			innerHTML: 'document.head.removeChild(document.querySelector(\'[data-monospace-theme]\'))',
		}];
	}

	useHead(headData);
});
